var sharePreview = {
    props: {
        tdk: Object,
        media: Number,
        video: String
    },
    data() {
        return {
            activeIndex: 0
        };
    },
    render(h) {
        function lineBreaks(arr) {
            var ret = [].concat.apply([], arr.map(t => [t, h('br')]));
            ret.pop();
            return ret;
        }
        var arr = [];
        var hasDesc = { 2: 1, 3: 1, 10: 1, 4: 1, 6: 1, 9: 1, 8: 1 }[this.media];
        var hasKeywords = { 3: 1, 8: 1 }[this.media];
        arr.push(h('h3', null, [this.tdk.title]));
        if (this.tdk.desc && hasDesc) {
            arr.push(h('p', null, lineBreaks(this.tdk.desc.split(/\n/))));
        }
        if (this.tdk.keywords && hasKeywords) {
            arr.push(h('p', {
                class: 'share-preview__keywords'
            }, ['Keywords: ', this.tdk.keywords]));
        }
        var mediaEl;
        if (this.video) {
            mediaEl = h('video', {
                class: 'share-preview__img',
                attrs: {
                    src: this.video,
                    controls: true
                }
            });
        }
        if (mediaEl) {
            arr[{ 3: 1, 10: 1, 6: 1, 4: 1, 8: 1 }[this.media] ? 'unshift' : 'push'](mediaEl);
        }
        return h('div', { class: 'share-preview' }, [
            h('p', { class: 'share-preview__warning' }, ['注：仅对发布的内容作展示，不代表最终样式']),
            arr
        ]);
    }
}
export default sharePreview;